export function buildJsonHeaders(token) {
    return ({
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
    });
}

export function hasAssignableQuestions(form) {
    return form.form_sections.some(
        (formSection) => formSection.section?.question_sections?.length > 0
    );
}

export function getRemovedIds(initialIds, selectedIds) {
    return initialIds.filter((id) => !selectedIds.includes(id));
}

export function getAddedIds(initialIds, selectedIds) {
    return selectedIds.filter((id) => !initialIds.includes(id));
}

export function buildAssignmentChangeSet(component) {
    const selectedProfileIds = [...component.selected_profiles];
    const selectedPortalIds = [...component.selected_portals];
    const removedProfileIds = getRemovedIds(component.initial_selected_profiles, selectedProfileIds);
    const removedPortalIds = getRemovedIds(component.initial_selected_portals, selectedPortalIds);
    const addedProfileIds = getAddedIds(component.initial_selected_profiles, selectedProfileIds);
    const addedPortalIds = getAddedIds(component.initial_selected_portals, selectedPortalIds);

    return ({
        selectedProfileIds,
        selectedPortalIds,
        removedProfileIds,
        removedPortalIds,
        addedProfileIds,
        addedPortalIds,
        hasAssignments: addedProfileIds.length > 0 || addedPortalIds.length > 0,
        hasUnassignments: removedProfileIds.length > 0 || removedPortalIds.length > 0,
    });
}

export function getAssignmentPayload(formId, profileTypeIds, portalIds, businessTab) {
    return {
        form_id: formId,
        profile_type_ids: profileTypeIds,
        portal_ids: portalIds,
        business_tab: businessTab || '',
    };
}

export function mapAssignedProfileIds(profileTypes, assignedProfileTypes = []) {
    return profileTypes
        .filter((profile) => assignedProfileTypes.includes(profile.name))
        .map((profile) => profile.id);
}

export function mapAssignedPortalIds(assignedPortals = []) {
    return assignedPortals.map((portal) => portal.id);
}

export function mapAssignedProfileNames(profileTypes, selectedProfileIds) {
    return profileTypes
        .filter((profile) => selectedProfileIds.includes(profile.id))
        .map((profile) => profile.name);
}

export function mapAssignedPortals(portals, selectedPortalIds) {
    return portals
        .filter((portal) => selectedPortalIds.includes(portal.id))
        .map((portal) => ({
            id: portal.id,
            name: portal.name,
        }));
}
